import * as React from 'react'
import styled, { css } from 'styled-components'

import * as plume from '@ulule/owl-kit-components/next'

type HorizontalMediaProps = {
  className?: string
  description: React.JSX.Element | React.ReactNode
  image: {
    src: string
    srcSet?: string | null
    alt?: string | null
  }
  title: React.JSX.Element | React.ReactNode
  backgroundColor: string
  reverse?: boolean
}

function HorizontalMediaComponent({
  backgroundColor,
  className,
  description,
  image,
  reverse = false,
  title,
}: HorizontalMediaProps) {
  return (
    <Wrapper reverse={reverse} className={className}>
      <Content>
        {title}

        <Line backgroundColor={backgroundColor} />

        {description}
      </Content>

      <Image alt="" src={image.src} srcSet={image.srcSet ?? ''} />
    </Wrapper>
  )
}
export const HorizontalMedia = styled(HorizontalMediaComponent)``

export const Image = styled(plume.Picture)`
  flex: none;
  margin-bottom: 32px;

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    margin: auto 50px auto 0px;

  }
`

export const Content = styled.div`
  color: ${plume.COLORS.TEXT_PRIMARY};
  line-height: 22px;
  font-size: 14px;
`

const Line = styled.div<{ backgroundColor: string }>`
  background-color: ${({ backgroundColor }) => backgroundColor};
  height: 7px;
  margin: 24px 0;
  width: 53px;
`

const Wrapper = styled.li<{ reverse: boolean }>`
  display: flex;
  flex-direction: column-reverse;
  margin-bottom: 56px;

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    ${({ reverse }) => {
      if (reverse) {
        return css`
          flex-direction: row;
          justify-content: space-between;

          ${Image} {
            margin-left: 50px;
            margin-right: 0;
          }
        `
      } else {
        return css`
          flex-direction: row-reverse;
          justify-content: space-between;
        `
      }
    }}
  }
`
